import React, { useEffect } from 'react'

import Nav from '../components/Nav';

import Footer from '../components/Footer';
import { register } from 'swiper/element/bundle';
import { useSearchParams } from "react-router-dom";

import '../styles/collectionscreen.css';

// Wanthla No. 1
import wanthla1 from '../assets/images/collection/wanthla/wantla-1.jpg';
import wanthla2 from '../assets/images/collection/wanthla/wantla-2.jpg';
import wanthla3 from '../assets/images/collection/wanthla/wantla-3.jpg';
import wanthla4 from '../assets/images/collection/wanthla/wantla-4.jpg';
import wanthla5 from '../assets/images/collection/wanthla/wantla-5.jpg';
import wanthla6 from '../assets/images/collection/wanthla/wanthla-i.jpg';
import wanthla7 from '../assets/images/collection/wanthla/wanthla-ii.jpg';
import wanthla8 from '../assets/images/collection/wanthla/wanthla-iii.jpg';
import wanthla9 from '../assets/images/collection/wanthla/wanthla-iv.jpg';
import wanthla10 from '../assets/images/collection/wanthla/wanthla-v.jpg';
import wanthla11 from '../assets/images/collection/wanthla/No-i.jpg';
import wanthla12 from '../assets/images/collection/wanthla/No-ii.jpg';
import wanthla13 from '../assets/images/collection/wanthla/No-iii.jpg';
import wanthla14 from '../assets/images/collection/wanthla/No-iv.jpg';
import wanthla15 from '../assets/images/collection/wanthla/No-v.jpg';

// Windows of Cradock

import woc1 from '../assets/images/collection/widows-of-cradock/image00001.jpeg'
import woc2 from '../assets/images/collection/widows-of-cradock/image00002.jpeg'
import woc3 from '../assets/images/collection/widows-of-cradock/image00003.jpeg'
import woc4 from '../assets/images/collection/widows-of-cradock/image00006.jpeg'
import woc5 from '../assets/images/collection/widows-of-cradock/image00011.jpeg'
import woc6 from '../assets/images/collection/widows-of-cradock/image00012.jpeg'
import woc7 from '../assets/images/collection/widows-of-cradock/image00013.jpeg'
import woc8 from '../assets/images/collection/widows-of-cradock/image00014.jpeg'
import woc9 from '../assets/images/collection/widows-of-cradock/image00015.jpeg'
import woc10 from '../assets/images/collection/widows-of-cradock/image00016.jpeg'
import woc11 from '../assets/images/collection/widows-of-cradock/image00017.jpeg'
import woc12 from '../assets/images/collection/widows-of-cradock/image00018.jpeg'
import woc13 from '../assets/images/collection/widows-of-cradock/image00019.jpeg'
import woc14 from '../assets/images/collection/widows-of-cradock/image00020.jpeg'
import woc15 from '../assets/images/collection/widows-of-cradock/image00022.jpeg'


const CollectionScreen = () => {
    const [searchParams] = useSearchParams();
    const collectionName = searchParams.get("name") || "wanthla" 

    useEffect(() => {
        document.title = `Jodorry | Collection | ${collectionName}`;
    }, [collectionName]);

    register();

    const collections = {
        "wanthla": {
            collection: "Wanthla No.1",
            images: [
                wanthla1, wanthla2, wanthla3, wanthla4, wanthla5,
                wanthla6, wanthla7, wanthla8, wanthla9, wanthla10,
                wanthla11, wanthla12, wanthla13, wanthla14, wanthla15,
            ]
        },
        "widows-of-cradock": {
            collection: "Widows of Cradock",
            images: [
                woc1, woc2, woc3, woc4, woc5,
                woc6, woc7, woc8, woc9, woc10,
                woc11, woc12, woc13, woc14, woc15,
            ]
        }
    }


    return (
        <>
            <Nav />
            <section className='collection-screen'>
                <div className='nav-color' />

                <div className="collection-center">
                    <div className='collection-content'>
                        <h4>
                            {collections[collectionName].collection}
                        </h4>
                        <div className='images-container'>
                            <swiper-container
                                pagination-clickable="true"
                                navigation="true"
                                navigation-next-el=".custom-next-button"
                                navigation-prev-el=".custom-prev-button"
                                pagination-dynamic-bullets="true"
                                autoplay-delay="5000"
                                autoplay-disable-on-interaction="false"
                                center-slides="true"

                                style={
                                    {
                                        "--swiper-navigation-color": "#CA054D",
                                        "--swiper-pagination-color": "#CA054D"
                                    }
                                }


                                breakpoints={
                                    JSON.stringify({
                                        640: {
                                            slidesPerView: 1,
                                        },
                                        768: {
                                            slidesPerView: 2,
                                        },
                                        1024: {
                                            slidesPerView: 3,
                                        }
                                    })
                                }
                            >
                                {collections[collectionName].images.map((image, index) => {
                                    return (
                                        <swiper-slide key={index} lazy="true"><img src={image} alt={collections.collection} className='collection-image' loading="lazy" /></swiper-slide>
                                    )
                                })
                                }
                            </swiper-container>
                        </div>
                    </div>
                </div>
            </section>
            <Footer theme="light" />
        </>
    )
}

export default CollectionScreen



